import React, { ReactElement } from "react";
import classNames from "classnames";
import { OrderChatMessage, OrderChatMessageStatus } from "@core/types";
import { isLaterIso } from "../../../../providers/Chat/timestamps";

type DisplayStatus = OrderChatMessageStatus | "read";

const resolveStatus = (message: OrderChatMessage, operatorLastReadAt: string | null): DisplayStatus => {
  if (message.status === "sending") return "sending";
  if (message.status === "failed") return "failed";
  return isLaterIso(operatorLastReadAt, message.createdAt) ? "read" : "sent";
};

const SVG_BY_STATUS: Record<DisplayStatus, ReactElement> = {
  sending: (
    <>
      <circle cx="256" cy="256" r="208" />
      <path d="M256 128v144l80 48" />
    </>
  ),
  failed: (
    <>
      <circle cx="256" cy="256" r="208" />
      <path d="M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z" />
      <path d="M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z" />
    </>
  ),
  sent: <path d="M416 128L192 384l-96-96" />,
  read: (
    <>
      <path d="M464 128L240 384l-32-32" />
      <path d="M336 128L112 384l-96-96" />
    </>
  ),
};

const COLOR_BY_STATUS: Record<DisplayStatus, string> = {
  sending: "text-gray-500",
  failed: "text-red-500",
  sent: "text-gray-500",
  read: "text-sky-500",
};

type Props = {
  message: OrderChatMessage;
  operatorLastReadAt: string | null;
};

const MessageStatusIcon = ({ message, operatorLastReadAt }: Props) => {
  const status = resolveStatus(message, operatorLastReadAt);

  return (
    <svg
      role="img"
      aria-label={status}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth={48}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={classNames("w-3.5 h-3.5 shrink-0", COLOR_BY_STATUS[status])}
    >
      {SVG_BY_STATUS[status]}
    </svg>
  );
};

export default MessageStatusIcon;
